import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import FilterCustom from "./Filter"
import DetailModal from "../Modal/DetailModal"
import ViewSimDetailModal from "../../SalesReport/Modal/ViewSimDetailModal"
import { set } from "lodash"
// import InventoryDetailModal from "../Modal/InventoryDetailModal"; // modal mới cho tồn kho

function ListInventory({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isSimModalOpen, setIsSimModalOpen] = useState(false)
  const [typeDetailSim, setTypeDetailSim] = useState(null)
  const [statistics, setStatistics] = useState(null)

  const fetchData = async (pagination, filter, keyword) => {
    setLoading(true)
    setParentFilter(filter)
    try {
      const res = await ReportsService.getListInventory({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter,
        keyword,
      })

      const list = res?.success?.data || []
      const stats = {
        inventory: res?.success?.Inventory || {},
        sim: res?.success?.Sim || {},
        amount: res?.success?.amount || {},
      }

      const formatted = list.map((item, index) => ({
        ...item,
        key: item.id || index,
        export_code: item?.export?.export_code || "",
        type_sim: item?.type_sim || "",
        package: item?.package?.name || "",
        // activation_deadline: item?.activation_deadline || "",
        // currency_type: item?.currency_type || "",
        sim_type: item?.sim_type || "",
        supplier: item?.supplier?.name || "",
        quantity: item?.quantity || 0,
        sim_fee: item?.sim_fee || 0,
        package_unit_price: item?.package_unit_price || 0,
        vat: item?.vat || 0,
        connection_fee: item?.connection_fee || 0,
        sold_quantity: item?.da_ban || 0,
        remain_quantity: item?.ton_kho || 0,
        customer: item?.customer?.fullname || "",
      }))

      setDataSource(formatted)
      setPagination({
        ...pagination,
        total: res?.success?.total || 0,
      })
      setStatistics(stats)
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])

  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({ ...prev, current: 1 }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])

  const columns = [
    // {
    //   title: "STT",
    //   dataIndex: "index",
    //   key: "index",
    //   align: "center",
    //   render: (text, record, index) =>
    //     (pagination.current - 1) * pagination.pageSize + index + 1,
    //   width: 60,
    // },
    {
      title: "Đơn hàng",
      dataIndex: "export_code",
      key: "export_code",
      align: "center",
      // render: (text, record) => (
      //   <a
      //     style={{ color: "#1890ff", cursor: "pointer" }}
      //     onClick={e => {
      //       e.stopPropagation()
      //       handleOpenDetailModal(record)
      //     }}
      //   >
      //     {text}
      //   </a>
      // ),
    },
    {
      title: "Khách hàng",
      dataIndex: "customer",
      key: "customer",
      align: "center",
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      key: "supplier",
      align: "center",
    },
    {
      title: "Số lượng",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      render: (value, record) => (
        <a
          style={{ color: "#28a745", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenSimModal(record, "all")
          }}
        >
          {value}
        </a>
      ),
    },
    {
      title: "Đã bán",
      dataIndex: "sold_quantity",
      key: "sold_quantity",
      align: "center",
      render: (value, record) => (
        <a
          style={{ color: "#28a745", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenSimModal(record, "sold")
          }}
        >
          {value}
        </a>
      ),
    },
    {
      title: "Còn lại",
      dataIndex: "remain_quantity",
      key: "remain_quantity",
      align: "center",
      render: (value, record) => (
        <a
          style={{ color: "#28a745", cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            handleOpenSimModal(record, "remain")
          }}
        >
          {value}
        </a>
      ),
    },
    // {
    //   title: "VAT",
    //   dataIndex: "vat",
    //   key: "vat",
    //   align: "right",
    //   render: value =>
    //     value ? new Intl.NumberFormat().format(Number(value)) : "",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Giá trước chiết khấu",
    //   dataIndex: "unit_price",
    //   key: "unit_price",
    //   align: "right",
    //   render: value =>
    //     value ? new Intl.NumberFormat().format(Number(value)) : "",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Giá sau chiết khấu",
    //   dataIndex: "end_price",
    //   key: "end_price",
    //   align: "right",
    //   render: value =>
    //     value ? new Intl.NumberFormat().format(Number(value)) : "",
    //   onHeaderCell: () => ({
    //     style: { textAlign: "center" },
    //   }),
    // },
    // {
    //   title: "Loại tiền tệ",
    //   dataIndex: "currency_type",
    //   align: "center",
    //   render: value => {
    //     if (value === "vnd") return "VND"
    //     if (value === "usd") return "USD"

    //     return value
    //   },
    // },
    // {
    //   title: "Thời gian phải kích hoạt",
    //   dataIndex: "activation_deadline",
    //   align: "center",
    //   render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    // },
  ]

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  const handleRowClick = record => {
    setSelectedRecord(record.ID)
    setIsDetailModalOpen(true)
  }
  const handleOpenDetailModal = record => {
    setSelectedRecord(record.ID)
    setIsDetailModalOpen(true)
  }
  const handleOpenSimModal = (record, type) => {
    setSelectedRecord(record)
    setTypeDetailSim(type)
    setIsSimModalOpen(true)
  }

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false)
    setIsSimModalOpen(false)
    setSelectedRecord(null)
  }

  return (
    <div>
      {/* <div style={{ display: "flex" }}>
        <FilterCustom setFilter={setFilter} setKeyword={setKeyword} />
      </div> */}

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#6f42c1", minWidth: "150px" }}>
          <strong>Tổng USIM: {statistics?.sim?.usim || 0}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#fd7e14", minWidth: "150px" }}>
          <strong>Tổng ESIM: {statistics?.sim?.esim || 0}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>Đã bán: {statistics?.inventory?.da_ban || 0}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tồn kho: {statistics?.inventory?.ton_kho || 0}</strong>
        </div>
      </div>

      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        // onRow={record => ({
        //   onClick: () => handleRowClick(record),
        // })}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />

      {/* {selectedRecord && (
        <DetailModal
          open={isDetailModalOpen}
          onCancel={handleCloseDetailModal}
          recordId={selectedRecord}
        />
      )} */}
      {isSimModalOpen && (
        <DetailModal
          open={isSimModalOpen}
          onCancel={handleCloseDetailModal}
          recordId={selectedRecord?.ID}
          api={ReportsService.getDetailInventory}
          type={typeDetailSim}
        />
      )}
    </div>
  )
}

export default ListInventory
